import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';

import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import FloatingCTA from './components/FloatingCTA';

import Home from './pages/Home';
import AboutPage from './pages/AboutPage';
import ServicesPage from './pages/ServicesPage';
import ErhvervIndustriPage from './pages/ErhvervIndustriPage';
import GalleryPage from './pages/GalleryPage';
import ContactPage from './pages/ContactPage';
import NotFoundPage from './pages/NotFoundPage';
import ForbiddenPage from './pages/ForbiddenPage';

export default function App() {
  return (
    <HelmetProvider>
      <ScrollToTop />
      <div className="min-h-screen flex flex-col bg-slate-50 text-slate-900 font-sans antialiased">
        <Navbar />
        <main className="flex-grow">
          <Routes>
            {/* Primary Pages */}
            <Route path="/" element={<Home />} />
            <Route path="/k-to-ventilationsteknik" element={<AboutPage />} />
            <Route path="/erhverv-og-industri" element={<ErhvervIndustriPage />} />
            <Route path="/galleri" element={<GalleryPage />} />
            <Route path="/kontakt" element={<ContactPage />} />

            {/* Service Subpages */}
            <Route path="/ydelser/:slug" element={<ServicesPage />} />

            {/* Legacy Scrape URL Redirects */}
            <Route path="/om-k-to-multiservice" element={<Navigate to="/k-to-ventilationsteknik" replace />} />
            <Route path="/service-og-ventilation" element={<Navigate to="/ydelser/service-og-ventilation" replace />} />
            <Route path="/indregulering" element={<Navigate to="/ydelser/indregulering" replace />} />
            <Route path="/fejlfinding-og-reparation" element={<Navigate to="/ydelser/fejlfinding-og-reparation" replace />} />
            <Route path="/rensning-af-ventilation" element={<Navigate to="/ydelser/rensning-af-ventilation" replace />} />
            <Route path="/kol" element={<Navigate to="/ydelser/kol" replace />} />
            <Route path="/ventilationsanlaeg-vejle" element={<Navigate to="/ydelser/service-og-ventilation" replace />} />
            <Route path="/ventilationsanlaeg-fredericia" element={<Navigate to="/ydelser/service-og-ventilation" replace />} />
            <Route path="/ventilationsanlaeg-kolding" element={<Navigate to="/ydelser/service-og-ventilation" replace />} />

            {/* Error Pages */}
            <Route path="/403" element={<ForbiddenPage />} />
            <Route path="/404" element={<NotFoundPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </main>
        <Footer />
        <FloatingCTA />
      </div>
    </HelmetProvider>
  );
}
